import { device } from 'constants/device';

import styled from 'styled-components';

export const Container = styled.div<{ idx: number }>`
  width: 295px;
  height: 150px;
  background-color: ${({ theme }) => theme.system.white};
  background-image: ${({ idx }) =>
    `url(assets/patterns/${(idx % 12) + 1}.svg)`};
  background-position: top left;
  background-repeat: no-repeat;
  border: 1px solid ${({ theme }) => theme.system.lightGrey};
  border-radius: 18px;
  padding-left: 75px;
  display: flex;
  place-items: center;
  overflow: hidden;
  font-size: 2rem;
  line-height: 140%;
  font-weight: bold;

  &:hover {
    border: 1px solid ${({ theme }) => theme.brand.blue};
  }

  @media ${device.tablet} {
    background-image: ${({ idx }) =>
      `url(assets/patterns/mobile-${(idx % 12) + 1}.svg)`};
    border-radius: 8px;
    font-size: 14px;
    width: 180px;
    height: 80px;
    padding-left: 40px;
  }
`;

export const TextWrapper = styled.div`
  padding: 24px;
  @media ${device.tablet} {
    padding: 12px;
  }
`;
